import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '@salesforce/retail-react-app/app/components/link'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getPDPath} from '../../../utils/custom-utils'

export const PopularCategory = ({custom, catDisplayName, imagesize, category}) => {
    const imageURL = custom?.image?.disBaseLink
    const [width, height] = imagesize?.split(' ') ?? ['200px', '200px']
    const {site, locale} = useMultiSite()

    const formattedTileUrl = getPDPath(category, site, locale)

    return (
        <Box className="popular-banner" width={width} textAlign="center" mb={4}>
            <Link to={formattedTileUrl}>
                <Box
                    backgroundImage={`url(${imageURL})`}
                    backgroundSize="cover"
                    width={width}
                    height={height}
                    borderRadius="50%"
                    mb={4}
                />
                {catDisplayName}
            </Link>
        </Box>
    )
}

PopularCategory.propTypes = {
    custom: PropTypes.object,
    catDisplayName: PropTypes.string,
    imagesize: PropTypes.string,
    category: PropTypes.string
}

export default PopularCategory
